import { apiRequest } from "@/services/api-client";
import { GetBoxesOutput } from "types/web-app";

export const getBoxes = () => apiRequest<GetBoxesOutput>("/box/list");
